/* eslint-disable */
export default {
  createCallLog: 'Crear reg. llamadas',
  viewInSalesforce: 'Ver en Salesforce',
  createLog: 'Crear registro',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
